

























































































import { Component, Vue } from "vue-property-decorator";
import {
  readUserProfile,
  readHasAdminAccess,
  readHasCityAdminAccess,
  readToken,
} from "@/store/main/getters";
import { readAdminCities, readAdminUsers } from "@/store/admin/getters";
import { dispatchGetCities, dispatchGetUsers } from "@/store/admin/actions";
import { api } from "@/api";

@Component
export default class Dashboard extends Vue {
  private analytics: any = null;

  get greetedUser() {
    const p = readUserProfile(this.$store);
    return p ? p.full_name || p.email : "";
  }

  get hasAdminAccess() {
    return readHasAdminAccess(this.$store);
  }

  get cities(): any[] {
    return readAdminCities(this.$store) || [];
  }

  get users(): any[] {
    return readAdminUsers(this.$store) || [];
  }

  get kpis() {
    const active = this.cities.filter((c: any) => c.is_active).length;
    return [
      { label: "Städte gesamt", value: this.cities.length, icon: "mdi-map-marker-multiple-outline", color: "primary" },
      { label: "Aktive Städte", value: active, icon: "mdi-check-decagram-outline", color: "success" },
      { label: "Inaktive Städte", value: this.cities.length - active, icon: "mdi-map-marker-off-outline", color: "grey" },
      { label: "Benutzer", value: this.users.length, icon: "mdi-account-group-outline", color: "info" },
    ];
  }

  get quickLinks() {
    const links: any[] = [];
    if (readHasCityAdminAccess(this.$store)) {
      links.push({ to: "/main/city/tickets", title: "Mängelmelder", subtitle: "Bürgermeldungen bearbeiten", icon: "mdi-ticket-outline", color: "primary" });
      links.push({ to: "/main/city/appearances", title: "Auftritte", subtitle: "News & Inhalte pflegen", icon: "mdi-post-outline", color: "accent" });
      links.push({ to: "/main/city/home-page", title: "Startseite", subtitle: "App-Startbildschirm", icon: "mdi-cellphone-text", color: "info" });
    }
    if (this.hasAdminAccess) {
      links.push({ to: "/main/admin/cities/all", title: "Städte verwalten", subtitle: "Alle Kommunen", icon: "mdi-map-marker-multiple-outline", color: "primary" });
      links.push({ to: "/main/admin/users/all", title: "Benutzer verwalten", subtitle: "Konten & Rechte", icon: "mdi-account-group", color: "secondary" });
    }
    links.push({ to: "/main/profile/view", title: "Mein Profil", subtitle: "Konto & Passwort", icon: "mdi-account-circle-outline", color: "blue-grey" });
    return links;
  }

  get maxMonth(): number {
    if (!this.analytics || !this.analytics.tickets_per_month.length) return 1;
    return Math.max(...this.analytics.tickets_per_month.map((m: any) => m.count), 1);
  }

  get maxCity(): number {
    if (!this.analytics || !this.analytics.tickets_per_city.length) return 1;
    return Math.max(...this.analytics.tickets_per_city.map((c: any) => c.count), 1);
  }

  public barHeight(count: number): string {
    return Math.max(3, Math.round((count / this.maxMonth) * 120)) + "px";
  }

  public cityPct(count: number): number {
    return (count / this.maxCity) * 100;
  }

  public async mounted() {
    try {
      if (this.hasAdminAccess) {
        await dispatchGetCities(this.$store, true);
        await dispatchGetUsers(this.$store);
      }
    } catch (e) {
      /* Kennzahlen optional */
    }
    try {
      const res = await api.getAnalyticsOverview(readToken(this.$store));
      this.analytics = res.data;
    } catch (e) {
      /* Aktivitäts-Auswertung optional */
    }
  }
}
